import producer from "immer";
import { getSessionStorageKey, setSessionStorageKey } from "../../../utils";
import { events } from "./events";

const INITIAL_STATE = {
	new_client: undefined,
	new_client_loading: false,
	new_client_success_data: undefined,
	new_client_error_data: undefined,
	new_client_field_params: undefined,
	new_client_field_update_loading: undefined,
	new_client_field_update_data: undefined,
	data_payment: undefined,
	payment_loading: undefined,
	payment_success_data: undefined,
	payment_error_data: undefined,
	is_form_initial_valid: undefined,
	main_color: "#F56426",
	user_registered_data: undefined,
	twygo_data: getSessionStorageKey("twygo_data") || undefined,
	onboard_data: getSessionStorageKey("onboard_data") || undefined,
	product_type_data: getSessionStorageKey("PRODUCT_TYPE_DEFAULT") || undefined,
	change_loading: undefined,
	nm_user_authenticated: undefined,
	token_login: undefined,
	cd_access_token: undefined,
	loading: false,
	updated_email: false,
	updated_client_origin: false,
	is_verifying_duplicity_email: false,
	is_updating_email: false,
	retry_get_cd_access_token: false,
	isUserRegistered: false,
};

export default function onboardSimple(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@onboardSimple/ON_NEW_CLIENT_FIELD_UPDATE_REQUEST": (draft) => {
			draft.new_client_field_params = action.payload.params;
		},
		"@onboardSimple/ON_NEW_CLIENT_FIELD_UPDATE_LOADING": (draft) => {
			draft.new_client_field_update_loading = action.payload.loading;
		},
		"@onboardSimple/ON_NEW_CLIENT_FIELD_UPDATE_STATUS": (draft) => {
			draft.new_client_field_update_data = action.payload.data;
		},
		"@onboardSimple/ON_PROCESS_CLIENT_CHECKOUT_REQUEST": (draft) => {
			draft.data_payment = action.payload.payment;
		},
		"@onboardSimple/ON_CLIENT_CHECKOUT_LOADING": (draft) => {
			draft.payment_loading = action.payload.loading;
		},
		"@onboardSimple/ON_CLIENT_CHECKOUT_SUCCESS": (draft) => {
			draft.payment_success_data = action.payload.data;
		},
		"@onboardSimple/ON_CLIENT_CHECKOUT_SERVICE_ERROR": (draft) => {
			draft.payment_error_data = action.payload.error;
		},
		"@onboardSimple/START_ONBOARD_SUCCESS": (draft) => {
			draft.cd_access_token = action.payload.cd_access_token;
		},
		"@onboardSimple/DISPATCH_FORM_IS_VALID": (draft) => {
			draft.is_form_initial_valid = action.payload.isValidForm;
		},
		"@onboardSimple/CHANGE_COLOR": (draft) => {
			draft.main_color = action.payload.main_color;
		},
		"@onboardSimple/VALIDATE_ONBOARDING_STATUS": (draft) => {
			draft.validate_status = action.payload.data;
		},
		"@onboardSimple/IS_USER_REGISTERED_DATA": (draft) => {
			draft.user_registered_data = action.payload.data;
		},
		"@onboardSimple/TWYGO_INTEGRATION_DATA": (draft) => {
			const twygo_data = action.payload.data;
			let session_twygo_data = getSessionStorageKey("twygo_data");
			if (!session_twygo_data) {
				setSessionStorageKey("twygo_data", twygo_data);
			}
			if (session_twygo_data && session_twygo_data.result) {
				const result = { ...session_twygo_data.result, ...twygo_data.result };
				session_twygo_data.result = result;
				setSessionStorageKey("twygo_data", session_twygo_data);
			}
			draft.twygo_data = getSessionStorageKey("twygo_data");
		},
		"@onboardSimple/ONBOARDING_DATA": (draft) => {
			const onboard_data = action.payload.data;
			setSessionStorageKey("onboard_data", onboard_data);
			draft.onboard_data = onboard_data;
		},
		"@onboardSimple/GOGOGO_REQUEST_STATUS": (draft) => {
			draft.gogogo_status = action.payload.data;
		},
		"@onboardSimple/PRODUCT_DEFAULT": (draft) => {
			const productData = action.payload.data;
			setSessionStorageKey("PRODUCT_TYPE_DEFAULT", productData);
			draft.product_type_data = productData;
		},
		"@onboardSimple/CHANGE_LOADING": (draft) => {
			draft.change_loading = action.payload.loading;
		},
		"@onboardSimple/SET_NAME_AUTHENTICATED": (draft) => {
			draft.nm_user_authenticated = action.payload.name;
		},
		"@onboardSimple/SET_TOKEN_LOGIN": (draft) => {
			draft.token_login = action.payload.token;
		},
		"@onboardSimple/LOADING": (draft) => {
			draft.loading = action.payload.loading;
		},
		"@onboardSimple/UPDATED_EMAIL": (draft) => {
			draft.updated_email = action.payload.updated_email;
		},
		"@onboardSimple/SET_UPDATED_CLIENT_ORIGIN": (draft) => {
			draft.updated_client_origin = action.payload.updated_client_origin;
		},
		"@onboardSimple/IS_VERIFYING_DUPLICITY_EMAIL": (draft) => {
			draft.is_verifying_duplicity_email = action.payload.is_verifying_duplicity_email;
		},
		"@onboardSimple/IS_UPDATING_EMAIL": (draft) => {
			draft.is_updating_email = action.payload.is_updating_email;
		},
		"@onboardSimple/RETRY_GET_CD_ACCESS_TOKEN": (draft) => {
			draft.retry_get_cd_access_token = action.payload.retry_get_cd_access_token;
		},
		"@onboardSimple/IS_USER_REGISTERED": (draft) => {
			draft.isUserRegistered = action.payload.param;
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
